import { Injectable } from '@angular/core';
import { ToastEnum } from '../../enums/toast.enum';
import { MessageService } from 'primeng/api';
import { LkAlertAppearedEventData } from '../contracts/lkAlertAppearedEventData';
import { NotificationBannerService } from '../../modules/notification-banner/notification-banner.service';

@Injectable({ providedIn: 'root' })
export class LkAlertAppearedEventHandler {
  public alertsLk: LkAlertAppearedEventData[] = [];
  constructor(
    private _messageService: MessageService,
    private _notificationBannerService: NotificationBannerService
  ) {}

  public async handle(alert: LkAlertAppearedEventData): Promise<void> {
    if (alert.isActive) {
      this._messageService.add({
        severity: 'info',
        summary: alert.text,
        closable: true,
        sticky: true,
        life: 3000,
        data: { message: alert.text, typeEnum: ToastEnum.infoToast },
      });

      /** Если у нас уже есть уведомление с таким id - то удаляем его*/
      this.alertsLk = this.alertsLk.filter((value) => value.id !== alert.id);
      this.alertsLk.push(alert);
      const messages = this.alertsLk.map((value) => value.text);
      this._notificationBannerService.notifications$.next(messages);
    }
  }
}
